
export const Giveaway = ({ obj = {}, fieldID = '', position, prview = false }) => {
    return("Giveaway")
    }